module.exports = __webpack_public_path__ + "assets/img/challenge.e11f56c5.jpg";